import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { SET_CLIENT_CONFIG, REPLACE_REDUCERS, SECURITY, GET_USERS, GET_JOBPACKS, GET_FEED, GET_GROUPS } from "./types";
var INITIAL_STATE = {
  profile: false,
  pages: false,
  reports: false,
  firebase: false,
  replacedReducers: false,
  config: false,
  users: false,
  jobpacks: false,
  usersLoaded: false,
  jobpacksLoaded: false,
  requestingJobs: false,
  requestingUsers: false,
  requestingActivities: false,
  activitiesLoaded: false,
  activities: false,
  groupsLoaded: false,
  groups: false
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case REPLACE_REDUCERS:
      {
        return _objectSpread({}, state, {
          replacedReducers: true
        });
      }

    case SET_CLIENT_CONFIG:
      {
        return _objectSpread({}, state, action.payload);
      }

    case SECURITY.REQUEST:
      {
        return _objectSpread({}, state, {
          requesting: true,
          config: false
        });
      }

    case SECURITY.FAIL:
      {
        return _objectSpread({}, state, {
          requesting: false,
          config: false
        });
      }

    case SECURITY.SUCCESS:
      {
        return _objectSpread({}, state, {
          requesting: false,
          config: action.payload
        });
      }

    case GET_USERS.REQUEST:
      {
        return _objectSpread({}, state, {
          requestingUsers: true,
          users: false
        });
      }

    case GET_USERS.FAIL:
      {
        return _objectSpread({}, state, {
          requestingUsers: false,
          usersLoaded: false,
          users: false
        });
      }

    case GET_USERS.SUCCESS:
      {
        return _objectSpread({}, state, {
          requestingUsers: false,
          usersLoaded: true,
          users: action.payload
        });
      }

    case GET_JOBPACKS.REQUEST:
      {
        return _objectSpread({}, state, {
          requestingJobs: true,
          jobpacks: false
        });
      }

    case GET_JOBPACKS.FAIL:
      {
        return _objectSpread({}, state, {
          requestingJobs: false,
          jobpacksLoaded: false,
          jobpacks: false
        });
      }

    case GET_JOBPACKS.SUCCESS:
      {
        return _objectSpread({}, state, {
          requestingJobs: false,
          jobpacksLoaded: true,
          jobpacks: action.payload
        });
      }

    case GET_FEED.REQUEST:
      {
        return _objectSpread({}, state, {
          requestingActivities: true,
          activities: false
        });
      }

    case GET_FEED.FAIL:
      {
        return _objectSpread({}, state, {
          requestingActivities: false,
          activitiesLoaded: false,
          activities: false
        });
      }

    case GET_FEED.SUCCESS:
      {
        return _objectSpread({}, state, {
          requestingActivities: false,
          activitiesLoaded: true,
          activities: action.payload
        });
      }

    case GET_GROUPS.REQUEST:
      {
        return _objectSpread({}, state, {
          requestingGroups: true,
          groups: false
        });
      }

    case GET_GROUPS.FAIL:
      {
        return _objectSpread({}, state, {
          requestingGroups: false,
          groupsLoaded: false,
          grpups: false
        });
      }

    case GET_GROUPS.SUCCESS:
      {
        return _objectSpread({}, state, {
          requestingGroups: false,
          groupsLoaded: true,
          groups: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});